import type {PropsWithChildren} from 'react';
import styles from './confirm-form-row.module.css';

type Props = PropsWithChildren<{
  readonly labelText: string;
}>;

export function ConfirmFormRow({labelText, children}: Props) {
  return (
    <div className={styles.row}>
      <div className={styles.labelCell}>
        <p className={styles.labelText}>{labelText}</p>
      </div>

      <div className={styles.fieldCell}>{children}</div>
    </div>
  );
}
